export default {
    data(){
        return {}
    },
    methods: {
        defaultMomentDateFormat () {
            return 'DD/MM/YYYY'
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/mixins/defaultDateFormats.js